import toast from "react-hot-toast";
import {
  ROLE_CREATE, ROLE_CREATE_SUCCESS, ROLE_CREATE_FAIL,
  ROLE_LIST, ROLE_LIST_SUCCESS, ROLE_LIST_FAIL,
  ROLE_UPDATE, ROLE_UPDATE_SUCCESS, ROLE_UPDATE_FAIL,
  ROLE_DELETE, ROLE_DELETE_SUCCESS, ROLE_DELETE_FAIL,
} from "../../actions/admin/AdminActions";

const initialState = {
  isLoading: false,
  roleList: [],
};

const roleReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ROLE_CREATE:
    case ROLE_UPDATE:
    case ROLE_DELETE:
    case ROLE_LIST:
      return { ...state, isLoading: true };

    case ROLE_LIST_SUCCESS:
      return { ...state, isLoading: false, roleList: payload.data };

    case ROLE_CREATE_SUCCESS:
    case ROLE_UPDATE_SUCCESS:
    case ROLE_DELETE_SUCCESS:
      toast.success(payload?.message);
      return { ...state, isLoading: false };

    case ROLE_CREATE_FAIL:
    case ROLE_UPDATE_FAIL:
    case ROLE_DELETE_FAIL:
    case ROLE_LIST_FAIL:
      toast.error(payload?.error?.data?.message);
      return { ...state, isLoading: false };

    default:
      return { ...state };
  }
};

export default roleReducer;
